const Search = {
  init() {
    this.clearSearch();
  },

  clearSearch() {
    const searchInput = document.getElementById("search-input");

    if (!searchInput) {
      return;
    }

    const closeButton = document.getElementById("clear-search");

    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim() !== "") {
        closeButton.classList.remove("hidden");
      } else {
        closeButton.classList.add("hidden");
      }
    });

    closeButton.addEventListener("click", function (e) {
      e.preventDefault();
      searchInput.value = "";
      closeButton.classList.add("hidden");
    });
  },
};

export default Search;
